export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  getAllSuccess(state, data) {
    state.listAll = data.content;
    state.loading = false;
  },
};
